import { createRouter, createWebHistory } from "vue-router";
import { H } from 'highlight.run';
import { useNewAccountStore } from '@/stores/newAccount'
import { useCategoriesStore } from "@/stores/categories";
import { useAuth } from '@/composables/useAuth'

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			path: '/callback',
			name: 'AuthCallback',
			component: () => import('@/views/auth-callback/auth-callback.vue'),
		},
		{
			path: "/",
			component: () => import("@/layouts/wrapper.vue"),
			children: [
				{
					path: '',
					component: () => import("@/views/dashboard/Dashboard.vue"),
					name: "Home",
				},
				{
					path: 'transactions',
					component: () => import("@/views/transactions/Transaction.vue"),
					name: "Transaction",
				},
				{
					path: 'transactions/:id',
					component: () => import("@/views/transactions/Transaction.vue"),
					name: 'AccountTransactions',
				},
				{
					path: "settings",
					name: "Settings",
					component: () => import("@/views/settings/settings.vue"),
				},
				{
					path: "auth",
					children: [
						{
							path: "signin",
							name: "Signin",
							component: () => import("@/views/login/login.vue"),
						},
						{
							path: "code",
							name: "AuthCode",
							component: () => import("@/views/authCode/authCode.vue"),
						},
					],
				},
			],
		},
	],
});

router.beforeEach(async (to, from, next) => {
	try {
		if (to.name === 'AuthCallback') return next();

		const accountStore = useNewAccountStore();
		const { isAuth, jwt, refreshSession, setUserAttributes, userAttributes } = useAuth();

		const notAuthRoutesNames = ['Auth', 'Signin', 'AuthCode'];
		const isTryingAccessAuthRoute = !notAuthRoutesNames.includes(to.name as string);

		const isLoggedIn = await isAuth();

		if (isTryingAccessAuthRoute) {
			if (isLoggedIn) {
				await refreshSession();
				await setUserAttributes();
				await accountStore.setHasSomeAccount();
				useCategoriesStore().init();

				H.identify((userAttributes.email as string), {
					name: userAttributes.name,
					id: userAttributes.$id,
				})

				return next();
			}

			return next({ name: "Signin" })
		}

		if (isLoggedIn && jwt.value) {
			await refreshSession();
			await setUserAttributes();
			return next({ name: 'Home' });
		}

		return next();
	} catch (error) {
		console.error(error);
		return next();
	}
})

export default router
